// extracted by mini-css-extract-plugin
export default {"home":"c-c_cP","home__content":"c-c_cQ"};